import React from 'react';

// Pagina nascosta /legis-privacy: non linkata da nessun pulsante/menu.
// Contenuto statico (IT) fornito per l'app Legis.
const LegisPrivacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-void-blue text-white">
      <main className="container mx-auto px-4 py-12 mt-16">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <h1 className="font-display text-4xl font-bold text-white mb-4">
              INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI
            </h1>
            <p className="text-lg text-gray-300">
              Legis — app di ricerca e consultazione legislativa di LegisRatio S.r.l.
            </p>
            <p className="text-sm text-gray-400 mb-6">Ultimo aggiornamento: 16 settembre 2026</p>
          </div>

          <div className="space-y-6 text-gray-300">
            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">1. Titolare del trattamento</h2>
              <p className="mb-4">
                Il Titolare del trattamento dei dati personali è LegisRatio S.r.l., con sede in piazzale Lavater, 3 –
                20133 Milano (MI), Italia.
              </p>
              <p className="mb-4">
                Contatto privacy:{' '}
                <a href="mailto:privacy@legisratio.it" className="text-mystic-violet hover:text-cosmic-teal underline">
                  privacy@legisratio.it
                </a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">2. Ambito di applicazione</h2>
              <p className="mb-4">
                La presente informativa descrive il trattamento dei dati personali effettuato tramite il sito web, la web
                application e l’app mobile Legis di LegisRatio (collettivamente, il “Servizio”), quando l’utente utilizza
                ricerca, consultazione, cronologia e Miei salvati (solo sul dispositivo) e gestione del proprio account.
              </p>
              <p className="mb-4">
                L’informativa è resa ai sensi degli articoli 12, 13 e 14 del Regolamento (UE) 2016/679 (“GDPR”) e della
                normativa applicabile in materia di protezione dei dati e comunicazioni elettroniche.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">3. Quali dati personali trattiamo</h2>

              <h3 className="text-2xl font-semibold text-white mb-3">3.1 Dati forniti direttamente dall&apos;utente</h3>
              <ul className="list-disc pl-6 mb-6">
                <li>dati identificativi e di contatto, quali nome, cognome ed e-mail, se richiesti per la registrazione o la gestione dell&apos;account;</li>
                <li>credenziali o identificativi tecnici necessari per autenticare l&apos;utente, senza conservare la password in chiaro;</li>
                <li>informazioni relative al profilo e alle preferenze dell&apos;utente, se utilizzate dal Servizio;</li>
                <li>comunicazioni inviate volontariamente al contatto privacy (non è previsto un sistema di ticket di assistenza);</li>
                <li>
                  nessun dato di pagamento trattato da LegisRatio: gli abbonamenti in-app (mensile e annuale) sono
                  acquistati esclusivamente tramite Apple App Store o Google Play; i dati di pagamento (es. carta,
                  fatturazione) sono trattati solo da Apple/Google come titolari autonomi secondo le loro informative.
                  La verifica dello stato di abbonato avviene solo sul dispositivo tramite StoreKit/Play Billing, senza
                  trasmissione né conservazione di ricevute o dati di acquisto sui server di LegisRatio;
                </li>
              </ul>

              <h3 className="text-2xl font-semibold text-white mb-3">3.2 Query, cronologia e Miei salvati (solo sul dispositivo)</h3>
              <p className="mb-4">
                Quando l’utente effettua una ricerca, il Servizio tratta la query inserita, i filtri selezionati, i
                documenti consultati e data/ora, esclusivamente per fornire il risultato richiesto.
              </p>
              <p className="mb-4">
                Le query possono contenere dati personali inseriti volontariamente dall’utente. Si raccomanda di non
                inserire dati personali non necessari, categorie particolari di dati ex art. 9 GDPR o dati di terzi.
              </p>
              <p className="mb-4">
                La query è conservata sui server IONOS nello Spazio Economico Europeo (SEE) in forma transitoria per un
                massimo di 10 secondi, il tempo necessario all’elaborazione, e poi cancellata. LegisRatio non conserva sui
                propri server alcuna cronologia delle ricerche. Cronologia e “Miei salvati” sono conservati esclusivamente
                sul dispositivo dell’utente, fino a cancellazione in-app o disinstallazione (salvo backup del sistema
                operativo gestito da Apple/Google).
              </p>

              <h3 className="text-2xl font-semibold text-white mb-3">3.3 Dati tecnici e di utilizzo</h3>
              <ul className="list-disc pl-6 mb-6">
                <li>indirizzo IP e informazioni tecniche di rete, nei limiti necessari alla sicurezza e al funzionamento;</li>
                <li>identificativi del dispositivo e/o dell&apos;installazione dell&apos;app, ove utilizzati;</li>
                <li>sistema operativo, browser/app version e informazioni tecniche analoghe;</li>
                <li>log di sicurezza e di sistema;</li>
                <li>informazioni relative all&apos;utilizzo del Servizio, comprese statistiche di sessione e funzionalità utilizzate;</li>
                <li>nessun dato raccolto tramite SDK o analytics di terzi nell’app; cookie solo tecnici sul sito secondo Cookie Policy; local storage sul dispositivo per cronologia e Miei salvati.</li>
              </ul>

              <h3 className="text-2xl font-semibold text-white mb-3">3.4 Autenticazione tramite OAuth</h3>
              <p className="mb-4">
                L’accesso avviene tramite OAuth di Apple, Google e Microsoft. LegisRatio riceve esclusivamente gli
                attributi necessari all’account (identificativo univoco del provider, nome, email ed eventuale verifica
                email), secondo le autorizzazioni concesse. Le credenziali non transitano mai da LegisRatio. Si applicano
                anche le informative dei rispettivi provider.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">4. Finalità e basi giuridiche</h2>
              <div className="overflow-x-auto rounded-lg border border-white/10">
                <table className="w-full text-left text-sm md:text-base">
                  <thead>
                    <tr className="bg-white/5 text-white">
                      <th className="p-4 font-semibold">Finalità</th>
                      <th className="p-4 font-semibold">Dati principali</th>
                      <th className="p-4 font-semibold">Base giuridica</th>
                      <th className="p-4 font-semibold">Conservazione</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-white/10">
                    <tr>
                      <td className="p-4">Fornire il Servizio e le ricerche legislative</td>
                      <td className="p-4">Account, query, dati tecnici</td>
                      <td className="p-4">Esecuzione del contratto / misure precontrattuali</td>
                      <td className="p-4">Query su server SEE: max 10 secondi, poi cancellazione; nessuna cronologia su server</td>
                    </tr>
                    <tr>
                      <td className="p-4">Gestire account; cronologia e salvati solo sul dispositivo</td>
                      <td className="p-4">Account; dati on-device</td>
                      <td className="p-4">Esecuzione del contratto</td>
                      <td className="p-4">Account fino a cancellazione + 30 gg per backup; dati on-device fino a cancellazione in-app/disinstallazione</td>
                    </tr>
                    <tr>
                      <td className="p-4">Sicurezza, prevenzione abusi e frodi</td>
                      <td className="p-4">IP, log, identificativi tecnici</td>
                      <td className="p-4">Legittimo interesse / obbligo legale, ove applicabile</td>
                      <td className="p-4">1 anno</td>
                    </tr>
                    <tr>
                      <td className="p-4">Gestione richieste volontarie al contatto privacy (nessun ticket)</td>
                      <td className="p-4">Dati di contatto e contenuto del messaggio</td>
                      <td className="p-4">Esecuzione del contratto / legittimo interesse</td>
                      <td className="p-4">1 anno</td>
                    </tr>
                    <tr>
                      <td className="p-4">Gestione delle funzioni da abbonato (ricerche illimitate)</td>
                      <td className="p-4">Nessun dato di pagamento presso il Titolare; verifica locale on-device dello stato di abbonato</td>
                      <td className="p-4">Esecuzione del contratto</td>
                      <td className="p-4">N/A presso il Titolare; ricevute e cronologia acquisti conservate da Apple/Google secondo le loro informative</td>
                    </tr>
                    <tr>
                      <td className="p-4">Adempimenti fiscali, contabili e legali</td>
                      <td className="p-4">Nessun dato presso il Titolare; fatturazione emessa da Apple/Google</td>
                      <td className="p-4">Obbligo legale del venditore (Apple/Google)</td>
                      <td className="p-4">N/A presso il Titolare</td>
                    </tr>
                    <tr>
                      <td className="p-4">Statistiche</td>
                      <td className="p-4">Nessuna analytics di terzi in app</td>
                      <td className="p-4">N/A</td>
                      <td className="p-4">N/A — nessuna analytics di terzi</td>
                    </tr>
                    <tr>
                      <td className="p-4">Marketing/comunicazioni promozionali</td>
                      <td className="p-4">Contatti e preferenze</td>
                      <td className="p-4">Consenso, ove richiesto</td>
                      <td className="p-4">Fino alla revoca / secondo criteri applicabili</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">5. Ricerche, cronologia e personalizzazione</h2>
              <p className="mb-4">
                Cronologia e “Miei salvati” sono conservati esclusivamente sul dispositivo e servono solo a mostrare
                all’utente le proprie ricerche e documenti salvati. L’utente può modificarli o cancellarli in-app; la
                disinstallazione li rimuove dal dispositivo (salvo backup OS).
              </p>
              <p className="mb-4">
                La cronologia sul dispositivo non è utilizzata da LegisRatio per finalità ulteriori. Non essendovi
                conservazione server oltre i 10 secondi, non vi sono analisi aggregate su query da parte del Titolare.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">6. Ricerca deterministica – nessuna intelligenza artificiale generativa</h2>
              <p className="mb-4">
                Il Servizio fornisce risultati di ricerca legislativa in modo deterministico (full-text e indici
                normativi). In questa versione nessuna query viene inviata a provider di IA generativa per produrre
                risposte, né utilizzata per addestrare modelli.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">7. Fornitori e destinatari dei dati</h2>
              <p className="mb-4">
                I dati sono trattati da fornitori nominati responsabili ex art. 28 GDPR con DPA, limitatamente a quanto
                necessario: hosting/infrastruttura (IONOS), autenticazione OAuth (Apple, Google, Microsoft). Nessuna
                analytics di terzi nell’app. I pagamenti in-app sono trattati esclusivamente da Apple e Google come
                titolari autonomi (vedi sezione 11).
              </p>
              <p className="mb-4">
                Elenco aggiornato: IONOS Group SE (hosting, Germania, responsabile); Apple Inc., Google LLC, Microsoft
                Corporation (solo OAuth, USA – vedi sezione Trasferimenti, responsabili per l’autenticazione); Apple Inc.
                e Google LLC anche come titolari autonomi per gli acquisti in-app (pagamenti, fatturazione, rinnovi,
                rimborsi) secondo le rispettive informative e termini di vendita.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">7-bis. Hosting – IONOS</h2>
              <p className="mb-4">
                Fornitore: IONOS Group SE, data center in Germania (SEE). Dati: query in transito (max 10 secondi), dati
                account, log tecnici. Ruolo: responsabile ex art. 28 GDPR con DPA.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">10. Cookie e strumenti di tracciamento</h2>
              <p className="mb-4">
                Sito e app usano solo strumenti tecnici necessari: cookie tecnici sul sito e local storage sul dispositivo
                per cronologia e Miei salvati. Nessun cookie di profilazione e nessun SDK di analytics terzi nell’app.
                Dettagli e durate nella Cookie Policy pubblicata sul sito.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">11. Abbonamenti in-app – pagamenti via Apple e Google</h2>
              <p className="mb-4">
                Legis offre un uso gratuito entro soglie (10 ricerche iniziali e 3 ricerche gratuite al giorno) e
                abbonamenti in-app mensili e annuali, auto-rinnovanti, acquistabili esclusivamente tramite Apple App Store
                (su iOS) o Google Play (su Android) per ricerche illimitate. Prezzi, durate ed eventuali periodi di offerta
                sono mostrati nello store al momento dell’acquisto.
              </p>
              <p className="mb-4">
                Il pagamento è addebitato sull’account Apple/Google dell’utente secondo i termini di vendita dello store.
                Rinnovo automatico, disdetta, fatture/ricevute e rimborsi sono gestiti interamente da Apple/Google dalle
                impostazioni dell’account dello store. LegisRatio non tratta dati di carte o di fatturazione, non emette
                fatture per gli abbonamenti e non può addebitare, rimborsare o disdire abbonamenti.
              </p>
              <p className="mb-4">
                Per la verifica delle funzioni da abbonato l’app controlla lo stato dell’abbonamento solo sul dispositivo
                (StoreKit / Play Billing), senza inviare né conservare ricevute o dati di acquisto sui server di
                LegisRatio. Per i trattamenti effettuati da Apple e Google in qualità di venditori si applicano le loro
                informative privacy e termini.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">12. Trasferimenti verso Paesi terzi</h2>
              <p className="mb-4">
                Server e query (max 10 secondi) in SEE presso IONOS Germania. Autenticazione OAuth con ricezione di
                attributi identificativi da Apple, Google e Microsoft (USA) con garanzie ex capo V GDPR (clausole
                contrattuali standard e, ove applicabile, EU-US Data Privacy Framework). Gli acquisti in-app sono
                trattati da Apple/Google (USA) come titolari autonomi secondo le loro informative; nessun dato di carta o
                di fatturazione transita o è conservato sui server SEE di LegisRatio. Nessun altro trasferimento
                extra-SEE: nessuna analytics di terzi, nessuna IA generativa.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">13. Conservazione dei dati</h2>
              <p className="mb-4">
                I dati sono conservati solo per il tempo necessario alle finalità indicate, salvo obblighi di legge,
                sicurezza o difesa di diritti.
              </p>
              <p className="mb-4">
                Criteri applicati: account fino a cancellazione + 30 giorni per backup; query max 10 secondi su server;
                cronologia/salvati solo sul dispositivo fino a cancellazione; log 1 anno; backup 1 anno rolling (senza
                query, mai persistite); nessuna analytics di terzi; nessun dato di acquisto conservato sui server di
                LegisRatio (verifica abbonamento solo on-device; ricevute conservate da Apple/Google).
              </p>
              <p className="mb-4">
                Il backup annuale non contiene query, conservate solo 10 secondi e mai incluse nei backup.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">13-bis. Flussi principali dei dati</h2>
              <p className="mb-4">In sintesi:</p>
              <ul className="list-disc pl-6 mb-6">
                <li>Accesso: login OAuth Apple/Google/Microsoft; LegisRatio riceve solo gli attributi necessari all’account.</li>
                <li>Ricerca: query a IONOS SEE, cancellata entro 10 secondi; copia locale in cronologia/salvati solo sul dispositivo.</li>
                <li>Abbonamento: acquisto, rinnovo e rimborso gestiti da Apple/Google; verifica dello stato di abbonato solo sul dispositivo, nessun dato di acquisto sui server di LegisRatio.</li>
                <li>Nessuna elaborazione con IA generativa in questa versione.</li>
                <li>Sicurezza: IP e log trattati da IONOS, conservati 1 anno.</li>
                <li>Nessuna analytics di terzi nell’app.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">14. Sicurezza</h2>
              <p className="mb-4">
                Il Titolare adotta misure tecniche e organizzative adeguate al rischio, tenendo conto della natura dei dati
                e dei rischi per i diritti e le libertà delle persone fisiche. Le misure possono comprendere controllo
                degli accessi, cifratura ove appropriata, segregazione degli ambienti, backup, logging, gestione delle
                vulnerabilità e procedure per la gestione degli incidenti.
              </p>
              <p className="mb-4">
                Nessun sistema può garantire sicurezza assoluta; il Titolare aggiorna le misure di sicurezza in funzione
                dell&apos;evoluzione tecnica e dei rischi.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">15. Trattamento di dati di terzi inseriti dall&apos;utente</h2>
              <p className="mb-4">
                L&apos;utente deve evitare di inserire nel Servizio dati personali di terzi quando non necessari. Qualora
                utilizzi funzioni che consentono di salvare o elaborare contenuti contenenti dati personali, l&apos;utente deve
                disporre della necessaria base giuridica per tale inserimento.
              </p>
              <p className="mb-4">
                Il Servizio non è destinato a richiedere categorie particolari di dati personali ai sensi dell&apos;art. 9
                GDPR. Qualora tali dati vengano inseriti volontariamente dall&apos;utente, il relativo trattamento deve essere
                valutato separatamente in relazione alla funzione concreta.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">16. Processo decisionale automatizzato e profilazione</h2>
              <p className="mb-4">
                Il Servizio non assume decisioni con effetti giuridici basate esclusivamente su trattamenti automatizzati e
                non effettua profilazione, scoring o ranking personalizzato con effetti significativi.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">17. Diritti dell&apos;interessato</h2>
              <p className="mb-4">
                Nei casi previsti dalla normativa, l&apos;interessato può esercitare i diritti di cui agli articoli 15-22
                GDPR, tra cui:
              </p>
              <ul className="list-disc pl-6 mb-6">
                <li>ottenere conferma dell&apos;esistenza o meno di dati personali che lo riguardano e accedervi;</li>
                <li>ottenere la rettifica dei dati inesatti o l&apos;integrazione di quelli incompleti;</li>
                <li>ottenere la cancellazione dei dati nei casi previsti;</li>
                <li>ottenere la limitazione del trattamento nei casi previsti;</li>
                <li>opporsi al trattamento basato sul legittimo interesse, per motivi connessi alla propria situazione particolare, nei limiti previsti;</li>
                <li>ricevere i dati in formato strutturato, di uso comune e leggibile da dispositivo automatico e trasmetterli ad altro titolare nei casi previsti;</li>
                <li>revocare il consenso precedentemente prestato, senza pregiudicare la liceità del trattamento basata sul consenso prima della revoca;</li>
                <li>non essere sottoposto, ove applicabile, a una decisione basata esclusivamente su un trattamento automatizzato nei casi previsti dall&apos;art. 22 GDPR.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">18. Come esercitare i diritti</h2>
              <p className="mb-4">
                Richieste a{' '}
                <a href="mailto:privacy@legisratio.it" className="text-mystic-violet hover:text-cosmic-teal underline">
                  privacy@legisratio.it
                </a>
                . Risposta entro 1 mese (prorogabile di 2 mesi per complessità). Cancellazione account anche in-app
                (Impostazioni &gt; Elimina account): cancella account e dati server (backup entro 30 giorni) e, se
                confermato, i dati locali; restano solo i dati con obbligo di legge (es. fiscali). Per l’identità sono
                chiesti solo dati strettamente necessari.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">19. Reclamo all&apos;autorità di controllo</h2>
              <p className="mb-4">
                Chi ritiene violato il GDPR può reclamare al Garante per la protezione dei dati personali
                (www.garanteprivacy.it) o all’autorità del proprio Stato UE.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">20. Minori</h2>
              <p className="mb-4">
                Il Servizio non è rivolto a minori di 14 anni. Sotto i 14 anni è necessario il consenso del titolare della
                responsabilità genitoriale secondo la normativa italiana.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">21. Modifiche alla presente informativa</h2>
              <p className="mb-4">
                La versione aggiornata è pubblicata all’URL pubblico del sito e resa disponibile in-app. In caso di
                modifiche rilevanti, comunicazione in-app o via email ove richiesto.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">22. Collegamenti e servizi di terzi</h2>
              <p className="mb-4">
                Il Servizio può contenere collegamenti a siti o servizi di terzi. Tali soggetti operano secondo le proprie
                informative privacy e LegisRatio non è responsabile dei trattamenti effettuati autonomamente da tali soggetti.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4">23. Riferimenti normativi</h2>
              <p className="mb-4">
                Regolamento (UE) 2016/679 (GDPR), in particolare artt. 5, 6, 9, 12-14, 15-22, 28, 32 e 44-49; normativa
                italiana applicabile in materia di protezione dei dati personali, incluso il D.Lgs. 196/2003 come modificato
                dal D.Lgs. 101/2018; normativa applicabile in materia di comunicazioni elettroniche e cookie.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LegisPrivacy;
